<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import menus from '../configs/menu.json'
import { DriverStore } from '../pinia/Driver'
import { useTheme } from '../composables/useTheme'
import NavRailItem from './NavRailItem.vue'
import WheelspinNav from './WheelspinNav.vue'
import Account from '../pages/Account.vue'
import Persona from '../pages/Persona.vue'
import Premium from '../pages/Premium.vue'
import Donation from '../pages/Donation.vue'
import Login from './Login.vue'

const Driver = DriverStore()
const route = useRoute()
const { mode, toggleMode } = useTheme()
const themeIcon = computed(() => mode.value === 'dark' ? 'white-balance-sunny' : 'mdi-weather-night')
const themeLabel = computed(() => mode.value === 'dark' ? 'Light mode' : 'Dark mode')

function isActive(menu) {
  if (menu.path === '/') return route.path === '/'
  const paths = Array.isArray(menu.active || menu.path) ? menu.active : [menu.active || menu.path]
  return paths.some((path) => route.path.startsWith(path))
}
</script>

<template><nav class="nav-rail">
    <div class="nav-section nav-section-main">
      <template v-for="menu in menus" :key="menu.name">
        <NavRailItem
          v-if="menu.icon === 'minecraft'"
          icon="minecraft"
          :label="menu.name"
          :href="menu.path"
          external
        />
        <NavRailItem
          v-else
          :icon="menu.icon"
          :label="menu.name"
          :to="menu.path"
          :active="isActive(menu)"
        />
      </template>
    </div>
    <div class="nav-rail-spacer" aria-hidden="true" />
    <div class="nav-section nav-section-footer">
      <WheelspinNav v-if="Driver.logged" />
      <Premium v-if="Driver.logged" />
      <Donation />
      <Persona v-if="Driver.logged" />
      <Account v-if="Driver.logged" />
      <Login />
      <NavRailItem :icon="themeIcon" :label="themeLabel" @click="toggleMode" />
    </div>
  </nav></template>

<style scoped>
.nav-rail {
  display:flex;
  flex-direction:column;
  flex:1;
  width:100%;
  min-height:0;
  height:100%;
  overflow:hidden;
  padding:6px 0 0}
.nav-section {
  display:flex;
  flex-direction:column;
  align-items:stretch;
  width:100%;
  flex-shrink:0;
  padding:0 15px;
  box-sizing:border-box}
.nav-section-main {
  flex:0 1 auto;
  min-height:0;
  max-height:100%;
  overflow-x:hidden;
  overflow-y:auto;
  overscroll-behavior:contain;
  scrollbar-width:none;
  -ms-overflow-style:none}
.nav-rail-spacer {
  flex:1 1 auto;
  min-height:0}
.nav-section-footer {
  flex:0 0 auto;
  padding:8px 15px 12px;
  border-top:1px solid var(--line)}
.nav-section-main::-webkit-scrollbar {
  width:0;
  height:0}
</style>
